import { Icon } from '@iconify/react';
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  Select,
  SelectItem,
} from '@nextui-org/react';
import { useState } from 'react';
import CreateExperimentModal from './components/create-experiment-modal';

export default function PlaygroundPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-2">
          <Button variant="light" className="gap-2">
            <Icon icon="material-symbols:arrow-back" />
            Back
          </Button>
          <h1 className="text-2xl">Playground 2</h1>
        </div>
        <div className="flex items-center gap-2">
          <Button variant="light">Private</Button>
          <Button variant="light">+ Prompt</Button>
        </div>
      </div>

      <div className="space-y-4">
        {/* Prompt Section */}
        <div className="border rounded-lg p-4">
          <div className="flex items-center gap-2 mb-4">
            <span className="bg-blue-100 p-2 rounded">A</span>
            <Select label="Prompt">
              <SelectItem key="gpt4">GPT-4</SelectItem>
            </Select>
          </div>
          <textarea
            className="w-full p-4 border rounded"
            placeholder="You are a helpful assistant"
          />
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end gap-2">
          <Dropdown size="sm">
            <DropdownTrigger>
              <Button size="sm" variant="flat">
                Dataset
              </Button>
            </DropdownTrigger>
            <DropdownMenu aria-label="Dataset options">
              <DropdownItem key="dataset1">Dataset 1</DropdownItem>
              <DropdownItem key="dataset2">Dataset 2</DropdownItem>
              <DropdownItem key="dataset3">Dataset 3</DropdownItem>
            </DropdownMenu>
          </Dropdown>

          <Dropdown size="sm">
            <DropdownTrigger>
              <Button size="sm" variant="flat">
                Scorers
              </Button>
            </DropdownTrigger>
            <DropdownMenu aria-label="Scorer options">
              <DropdownItem key="scorer1">Accuracy</DropdownItem>
              <DropdownItem key="scorer2">Precision</DropdownItem>
              <DropdownItem key="scorer3">Recall</DropdownItem>
            </DropdownMenu>
          </Dropdown>

          <Button size="sm" variant="flat" onPress={() => setIsModalOpen(true)}>
            + Experiment
          </Button>
          <Button size="sm" color="primary">
            Run
          </Button>
        </div>
      </div>

      <CreateExperimentModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
}
